// Google Consent Mode v2 helpers
// Consent is denied by default (see public/index.html) and only updated after user interaction.

const STORAGE_KEY = "argengeo_cookie_consent_v1";

export const DEFAULT_CONSENT = {
  necessary: true,
  analytics: false,
  marketing: false,
  personalization: false,
};

function gtag() {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

export function readConsent() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_CONSENT, ...parsed };
  } catch (e) {
    return null;
  }
}

export function saveConsent(prefs) {
  if (typeof window === "undefined") return;
  const normalized = { ...DEFAULT_CONSENT, ...prefs, necessary: true };
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
  } catch (e) {
    // ignore
  }
  applyConsent(normalized);
  return normalized;
}

export function applyConsent(prefs) {
  if (typeof window === "undefined") return;
  const update = {
    ad_storage: prefs.marketing ? "granted" : "denied",
    ad_user_data: prefs.marketing ? "granted" : "denied",
    ad_personalization: prefs.marketing ? "granted" : "denied",
    analytics_storage: prefs.analytics ? "granted" : "denied",
    functionality_storage: "granted",
    personalization_storage: prefs.personalization ? "granted" : "denied",
    security_storage: "granted",
  };
  gtag("consent", "update", update);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "cookie_consent_update", consent: update });
}

export function acceptAll() {
  return saveConsent({
    necessary: true,
    analytics: true,
    marketing: true,
    personalization: true,
  });
}

export function rejectAll() {
  return saveConsent({
    necessary: true,
    analytics: false,
    marketing: false,
    personalization: false,
  });
}

export function reapplyOnLoad() {
  const stored = readConsent();
  if (stored) applyConsent(stored);
  return stored;
}
